<template>
  <section v-if="images.length" class="product-views">
    <h2 class="more-details-title">{{ $store.getters.t('productViews') }}</h2>
    <div class="product-views__carousel">
      <div
        class="product-views__frame"
        @touchstart.passive="handleTouchStart"
        @touchend.passive="handleTouchEnd"
        @mouseenter="stopTimer"
        @mouseleave="startTimer"
      >
        <img
          v-if="currentImage && !imageFailed"
          :src="currentImage"
          :alt="product.name || $store.getters.t('productImage')"
          @error="imageFailed = true"
        >
        <span v-else class="product-views__placeholder">{{ product.name || $store.getters.t('product') }}</span>
        <button
          v-if="images.length > 1"
          type="button"
          class="detail-carousel__arrow detail-carousel__arrow--left"
          aria-label="Previous product view"
          @click="previous"
        ><span></span></button>
        <button
          v-if="images.length > 1"
          type="button"
          class="detail-carousel__arrow detail-carousel__arrow--right"
          aria-label="Next product view"
          @click="next"
        ><span></span></button>
      </div>
      <div v-if="images.length > 1" class="detail-carousel__dots">
        <button
          v-for="(image, index) in images"
          :key="`${image}-${index}`"
          type="button"
          :class="{ active: index === activeIndex }"
          :aria-label="`Go to product view ${index + 1}`"
          @click="goTo(index)"
        ></button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductViews',
  props: { product: { type: Object, default: () => ({}) } },
  data () { return { activeIndex: 0, imageFailed: false, touchStartX: 0, touchStartY: 0, timer: null } },
  computed: {
    // 只取后台「PRODUCT VIEWS 图片」单独上传的图，不再映射上方详情轮播图
    images () {
      const list = this.product.viewImages || this.product.view_images || []
      const urls = (Array.isArray(list) ? list : [])
        .map(item => typeof item === 'string' ? item : item && (item.imageUrl || item.image_url || item.url))
        .filter(Boolean)
      return urls.filter((image, index) => urls.indexOf(image) === index)
    },
    currentImage () { return this.images[this.activeIndex] || '' }
  },
  watch: {
    product () { this.activeIndex = 0; this.imageFailed = false; this.startTimer() },
    activeIndex () { this.imageFailed = false },
    images () { this.startTimer() }
  },
  mounted () { this.startTimer() },
  beforeDestroy () { this.stopTimer() },
  methods: {
    next () {
      if (this.images.length < 2) return
      this.activeIndex = (this.activeIndex + 1) % this.images.length
    },
    previous () {
      if (this.images.length < 2) return
      this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length
    },
    goTo (index) { this.activeIndex = index; this.startTimer() },
    // 手机端没有箭头，靠自动轮播 + 左右滑动切换
    isMobile () { return typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches },
    startTimer () {
      this.stopTimer()
      if (!this.isMobile() || this.images.length < 2) return
      this.timer = window.setInterval(this.next, 5000)
    },
    stopTimer () {
      if (this.timer) window.clearInterval(this.timer)
      this.timer = null
    },
    handleTouchStart (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch) return
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
      this.stopTimer()
    },
    handleTouchEnd (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch || !this.touchStartX) return
      const dx = touch.clientX - this.touchStartX
      const dy = touch.clientY - this.touchStartY
      this.touchStartX = 0
      if (this.images.length > 1 && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) this.next()
        else this.previous()
      }
      this.startTimer()
    }
  }
}
</script>
